import { queryClient } from "services/api";

export const invalidateClaimsQuery = () => queryClient.invalidateQueries(["claims"]);
